module.exports = class {
    onCreate(input) {
        this.state = {
            placementId: input.id,
            module: input.module,
            options: input.options
        };
    }
    onMount() {
        document.addEventListener(`deli-received-response-PLACEMENT_${this.state.placementId}`, (e) => {
            this.state.module = e.detail;
        });
    }
};
